<div class="dash-card">
    <div class="row dash-card-header" *ngIf="!loading">
        <div class="col-6">
            <h2>{{data.user}}</h2>
            <app-spacer [bottom]="16"></app-spacer>

            <div class="d-flex align-items-center">
                {{formatDocument('cpf',data.document_number)}} • {{data.type}}
                <app-spacer [right]="16"></app-spacer>
                <svg-icon src="assets/images/icon-check-filled.svg"
                    fill="var(--success)"
                    *ngIf="data.status === 'Ativo'"></svg-icon>
                <svg-icon src="assets/images/icon-ban.svg" fill="var(--danger)"
                    *ngIf="data.status === 'Inativo'"></svg-icon>
                <app-spacer [right]="8"></app-spacer>
                {{data.status === 'Ativo' ? 'Ativo' : 'Inativo'}}
            </div>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
            <app-button (onClick)="toggleResetModal()"
                *ngIf="permissionObj.canReset" [outline]="true">
                Redefinir senha
            </app-button>
            <app-spacer [right]="16"></app-spacer>

            <app-button (onClick)="toggleUserModal()"
                *ngIf="permissionObj.canChange" [outline]="true">
                Editar usuário
            </app-button>
            <app-spacer [right]="16"></app-spacer>

            <app-button (onClick)="toggleUserStatus()"
                [danger]="data.status === 'Ativo'"
                *ngIf="permissionObj.canInactive">
                {{data.status === 'Ativo' ? 'Inativar usuário' :'Ativar
                usuário'}}
            </app-button>
        </div>
    </div>
</div>
<app-spacer [bottom]="48"></app-spacer>

<div class="dash-card">
    <div style="padding: 30px 30px 20px" *ngIf="!loading">
        <div class="row">
            <div class="col-lg-6">
                <p class="title">
                    Empresa
                </p>
                <p class="label">
                    {{ data.company.length > 0 && data.company[0].document ?
                    formatDocument('cnpj',data.company[0].document) :
                    '-'}}
                    <ng-container *ngIf="data.user_permissions.length > 0">
                        |
                        {{data.user_permissions[0].company_name}}
                    </ng-container>
                </p>
            </div>
            <div class="col-lg-3">
                <p class="title">
                    Departamento
                </p>
                <p class="label">
                    {{data.department ?? '-'}}
                </p>
            </div>


            <div class="col-lg-12">
                <app-spacer [bottom]="24"></app-spacer>
                <p class="title">
                    Grupo de usuários
                </p>
                <p class="label">
                    {{data.group}}
                </p>
            </div>
        </div>
        <app-spacer [bottom]="24"></app-spacer>
        <div class="row">
            <div class="col-lg-3">
                <p class="title">
                    Data de inclusão
                </p>
                <p class="label">
                    {{data.created_at}}
                </p>
            </div>
            <div class="col-lg-3">
                <p class="title">
                    Data e inativação
                </p>
                <p class="label">
                    {{data.inactive_at ?? '-'}}
                </p>
            </div>
            <div class="col-lg-3">
                <p class="title">
                    Data de reativação
                </p>
                <p class="label">
                    {{data.active_at ?? '-'}}
                </p>
            </div>
            <div class="col-lg-3">
                <p class="title">
                    Ultima alteração de senha
                </p>
                <p class="label">
                    {{data.change_password_at ?? '-'}}
                </p>
            </div>
        </div>
    </div>
</div>
<app-spacer [bottom]="48"></app-spacer>


<ng-container *ngIf="canViewHistory">
    <div class="dash-card no-padding">
        <div class="dash-card-header d-block">
            <ng-container *ngIf="historyLoading">
                <ngx-skeleton-loader [theme]="{
                            width: '80px',
                            height: '25px'
                          }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!historyLoading && historyData.length > 0">
                <h2>Histórico</h2>
                <app-spacer [bottom]="16"></app-spacer>
            </ng-container>
        </div>

        <div class="dash-card-body padding-container">
            <ng-container *ngIf="historyLoading">
                <table #table>
                    <thead>
                        <tr>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <table class="bordered"
                *ngIf="!historyLoading && historyData.length > 0">
                <thead>
                    <tr>
                        <th>Evento</th>
                        <th>Usuário</th>
                        <th>Data</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of historyData">
                        <td>
                            {{item.action}}
                        </td>

                        <td>
                            {{item.created_by}}
                        </td>

                        <td>
                            {{item.created_at}}
                        </td>
                    </tr>
                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>

            <ng-container *ngIf="!historyLoading && historyData.length === 0">
                <app-empty-content [isVisible]="true" [large]="true"
                    title="Não há nenhum histórico de usuário para exibir"
                    description="Não há histórico deste usuário para ser exibido no momento"
                    icon="/assets/images/figure_3d_search.png">
                </app-empty-content>
            </ng-container>
        </div>
    </div>

    <div class="col-12 ml-auto mr-auto" *ngIf="historyData.length > 0">
        <div class="dash-card-pagination">
            <app-pagination [data]="historyData" [count]="historyCount"
                [show]="!historyLoading" [offset]="historyOffset"
                (onPageChange)="changePageData($event)" [dashPagination]="true">
            </app-pagination>
        </div>
    </div>
</ng-container>

<app-side-modal [active]="showUserModal" title="Editar usuário"
    (onClose)="showUserModal = false">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-12">
                <p>Tipo de usuário</p>
                <app-spacer [bottom]="16"></app-spacer>

                <div class="d-flex">
                    <app-radio [multiple]="true"
                        (onCheckChanged)="handleChangeValue('simple')"
                        [isChecked]="isSimple">
                        <div class="flex-1 d-flex flex-column">
                            <span class="pep-title">Usuário comum</span>
                        </div>
                    </app-radio>
                    <app-spacer [right]="24"></app-spacer>

                    <ng-container>
                        <!-- <ng-container *ngIf="acitveRegisterMasterUser"> -->
                        <app-radio [multiple]="true"
                            (onCheckChanged)="handleChangeValue('master')"
                            [isChecked]="isMaster">
                            <div class="flex-1 d-flex flex-column">
                                <span class="pep-title">Usuário master</span>
                            </div>
                        </app-radio>
                    </ng-container>
                </div>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12" *ngIf="!isMaster">
                <app-select [items]="departmentOptions" [group]="form"
                    controlName="department" placeholder="Selecione"
                    label="Departamento">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12" *ngIf="isSimple">
                <app-select [items]="profileOptions" [group]="form"
                    controlName="profile" placeholder="Selecione"
                    label="Perfil de acesso">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-input [group]="form" controlName="name"
                    label="Nome completo" placeholder="Digite">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-lg-6">
                <app-masked-input [group]="form" controlName="document"
                    [readOnly]="true" label="CPF" documentType="cpfOrCnpj"
                    [isDocument]="true">
                </app-masked-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-lg-6">
                <app-input [group]="form" controlName="email" label="E-mail"
                    placeholder="Digite">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

        </div>

        <app-spacer [bottom]="64"></app-spacer>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="handleCloseModal()" class="add-button"
                    [phantom]="true">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="submit()" [disabled]="getDisabled()"
                        class="add-button" [loading]="submiting">
                        Salvar usuário
                    </app-button>
                </div>
            </div>
        </div>
    </form>
</app-side-modal>

<ng-container *ngIf="!loading">
    <app-warning-modal [active]="showResetModal" (onClose)="toggleResetModal()">
        <h3>Redefinir senha</h3>
        <app-spacer [bottom]="24"></app-spacer>
        <p>
            Tem certeza que gostaria de redefinir a senha desse usuário? A nova
            senha será encaminhada ao e-mail registrado para que o usuário possa
            acessar o sistema e a altere por uma nova.
        </p>
        <app-spacer [bottom]="18"></app-spacer>

        <p>Usuário: {{data.name}}</p>
        <p>E-mail cadastrado: {{data.email}}</p>
        <app-spacer [bottom]="56"></app-spacer>

        <app-button (onClick)="toggleResetModal()" [center]="true"
            [danger]="true" [loading]="sendEmail">
            Cancelar
        </app-button>
        <app-spacer [bottom]="8"></app-spacer>
        <app-button (onClick)="resetPassword()" [center]="true"
            class="add-button" [loading]="sendEmail">
            Redefinir senha
        </app-button>
    </app-warning-modal>
</ng-container>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>